<template>
  <ValidationObserver ref="overviewPage" id="overviewPage" name="overviewPage">
    <div v-if="policy">
      <b-card border-variant="primary" header-bg-variant="primary" header-text-variant="white" header-class="p-3 font-size-lg font-weight-bold">

        <div class="form-group row mb-0">
          <label class="col-2 col-form-label text-right font-size-h5">Client</label>
          <label class="col-2 col-form-label font-size-h5 font-weight-bolder">
            <a
              v-if="policy.K_Client && policy.K_Client.id"
              href="#"
              class="text-dark"
              @click.prevent="$router.push(`/workbench/clients/${policy.K_Client.id}`)"
            >{{ policy.K_Client.name }}</a>
            <span v-else>{{ policy.K_Client && policy.K_Client.name }}</span>
          </label>

          <label class="col-2 col-form-label text-right font-size-h5">Policy Number</label>
          <label class="col-2 col-form-label font-size-h5 font-weight-bolder">{{ policy.K_PolicyNumber }}</label>

          <label class="col-2 col-form-label text-right font-size-h5">Brand</label>
          <label class="col-2 col-form-label font-size-h5 font-weight-bolder">{{ policy.K_Brand }}</label>
        </div>

        <div class="form-group row mb-0">
          <label class="col-2 col-form-label text-right font-size-h5">Policy Start Date</label>
          <label class="col-2 col-form-label font-size-h5 font-weight-bolder">{{ policy.K_PolicyStartDate | dateParse("YYYY-MM-DD") | dateFormat("DD/MM/YYYY") }}</label>

          <label class="col-2 col-form-label text-right font-size-h5">Policy End Date</label>
          <label class="col-2 col-form-label font-size-h5 font-weight-bolder">{{ policy.K_PolicyEndDate | dateParse("YYYY-MM-DD") | dateFormat("DD/MM/YYYY") }}</label>

<!--          <label class="col-2 col-form-label text-right font-size-h5">Excess</label>-->
<!--          <label class="col-2 col-form-label font-size-h5 font-weight-bolder">{{ policy.K_PolicyExcess | currency("$", ",", 0, ".", "front", true) }}</label>-->
        </div>

      </b-card>
    </div>
  </ValidationObserver>
</template>

<style lang="scss">
</style>

<script>

export default {
  name: "OverviewPage",

  components: {},

  props: {
    policy: Object
  },

  data() {
    return {
    };
  },

  computed: {
  },

  methods: {
  }
};
</script>
